import React from "react";
import { Search } from "lucide-react";

const filters = [
  { id: "practice-status", label: "Practice Status" },
  { id: "order-by", label: "Order By" },
  { id: "badge", label: "Badge" },
  { id: "complexity", label: "Complexity" },
  { id: "pagination", label: "Pagination", hideOnMobile: true },
];

const FilterHeader = () => {
  return (
    <div className="grid gap-3 lg:grid-cols-[minmax(220px,1.4fr),repeat(5,minmax(120px,1fr))]">
      <label className="relative block">
        <span className="sr-only">Search</span>
        <input
          type="text"
          id="Search"
          placeholder="Search for..."
          className="h-[46px] w-full rounded-md border border-slate-200 bg-white py-2.5 pe-11 ps-3 text-sm text-gray-700 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-purple-300 focus:ring-2 focus:ring-purple-100"
        />

        <span className="absolute inset-y-1 end-1 grid w-9 place-content-center rounded-md bg-slate-100 text-gray-500">
          <Search className="h-4 w-4" aria-hidden="true" />
        </span>
      </label>

      {filters.map((filter) => (
        <label
          key={filter.id}
          htmlFor={filter.id}
          className={`block ${filter.hideOnMobile ? "hidden sm:block" : ""}`}
        >
          <span className="block text-xs font-bold uppercase text-gray-500">
            {filter.label}
          </span>

          <select
            name={filter.id}
            id={filter.id}
            className="mt-1.5 h-10 w-full rounded-md border border-slate-200 bg-white px-3 text-sm text-gray-700 shadow-sm outline-none transition focus:border-purple-300 focus:ring-2 focus:ring-purple-100"
          >
            <option value="">Please select</option>
            <option value="all">All</option>
          </select>
        </label>
      ))}
    </div>
  );
};

export default FilterHeader;
